import mlsTeamConfig from './mls-team-config.json';

type MlsTeamEntry = {
  displayName: string;
  canonicalSlug: string;
  legacySlugs: string[];
  teamListName?: string;
};

const teams = (mlsTeamConfig.teams as MlsTeamEntry[]).map((team) => ({
  ...team,
  fileName: team.displayName,
}));

const displayNameBySlug = new Map<string, string>();
const fileNameBySlug = new Map<string, string>();
const teamListNameBySlug = new Map<string, string>();

teams.forEach((team) => {
  displayNameBySlug.set(team.canonicalSlug, team.displayName);
  fileNameBySlug.set(team.canonicalSlug, team.fileName);
  teamListNameBySlug.set(
    team.canonicalSlug,
    team.teamListName ?? team.displayName
  );

  team.legacySlugs.forEach((slug) => {
    displayNameBySlug.set(slug, team.displayName);
    fileNameBySlug.set(slug, team.fileName);
    teamListNameBySlug.set(slug, team.teamListName ?? team.displayName);
  });
});

export const MLS_TEAM_CONFIG = teams;

export const getMlsTeamDisplayName = (slug = '') =>
  displayNameBySlug.get(String(slug).toLowerCase().trim());

export const getMlsTeamFileName = (slug = '') =>
  fileNameBySlug.get(String(slug).toLowerCase().trim());

export const getMlsTeamListName = (slug = '') =>
  teamListNameBySlug.get(String(slug).toLowerCase().trim());
